import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  chartTitle: {
    fontSize: '20px',
    marginTop: '24px',
    fontWeight: 600,
    textAlign: 'center',
    fill: theme?.palette?.mode === 'dark' ? '#fff' : '#333333',
  },
}));

const SnapshotTitle = ({ title }) => {
  const classes = useStyles();
  return <div className={classes.chartTitle}>{title}</div>;
};

export default SnapshotTitle;
